module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box flex-col"
  }, _vm._l((_vm.fileList), function(file, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-block flex-col",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(file)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('img', {
      staticClass: "file-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(file.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(file.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(file.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557fa056","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/DownloadArticleInfoSheet.vue
// module id = 1639
// module chunks = 8